let $body, scrollPosition;

function bodyFixedOn() {
	scrollPosition = window.pageYOffset;
	$body.style.position = 'fixed';
	$body.style.top = `-${scrollPosition}px`;
}

function bodyFixedOff() {
	$body.style.removeProperty('position');
	$body.style.removeProperty('top');
	window.scrollTo(0, scrollPosition);
}

function scrolled() {
	const _scrld_opt = {
		root: null,
		rootMargin: '100% 0px -101%',
		threshold: 0
	}
	const scrld = new IntersectionObserver(is_scrld, _scrld_opt);
	function is_scrld(ent) {
		ent.forEach(function (en) {
			if (en.isIntersecting) {
				$body.classList.add('is-scroll');
			} else {
				$body.classList.remove('is-scroll');
			}
		});
	}
	scrld.observe($body);
}

function scrollTop() {
	const $pageTop = document.querySelector('.page-top__btn');
	$pageTop.onclick = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}
}

function drawerTgl() {
	const $tgl = document.querySelectorAll('[data-drawer-tgl]');
	if ($tgl.length > 0) {
		const $drawer = document.querySelector('.drawer');

		$tgl.forEach(t => {
			t.onclick = () => {
				if ($body.classList.contains('is-drawer-show')) {
					bodyFixedOff();
					$body.classList.add('is-drawer-closing');
				} else {
					bodyFixedOn();
				}
				$body.classList.toggle('is-drawer-show');
			}
		});

		$drawer.addEventListener('transitionend', () => {
			if ($body.classList.contains('is-drawer-closing')) {
				$body.classList.remove('is-drawer-closing');
			}
		});
	}
}

function tglHeaderSearch() {
	const $tgl = document.querySelector('.header-search .header-search__tgl');
	if ($tgl) {
		const $pare = $tgl.closest('.header-search');
		$tgl.onclick = () => {
			$pare.classList.toggle('is-show-search');
		}
	}
}

function idxRecoSlide() {
	const $reco = document.querySelector('#idx_reco_splide');
	if ($reco) {
		const grid = document.createElement('script');
		grid.src = splideExUrl;
		grid.async = true;
		document.head.appendChild(grid);
		grid.onload = () => {
			const $recoSplide = new Splide($reco, {
				rewind: true,
				gap: 10,
				arrows: false,
				pagination: false,
				mediaQuery: 'min',
				grid: {
					rows: 2,
					cols: 1,
					gap: {
						row: 24,
						col: 10
					}
				},
				breakpoints: {
					750: {
						gap: 24,
					},
					1156: {
						grid: {
							rows: 2,
							cols: 4,
							gap: {
								row: 32,
								col: 32,
							}
						}
					},
				}
			});
			$recoSplide.mount(window.splide.Extensions);
		}
	}
}

function idxBlogSlide() {
	const $blog = document.querySelector('#idx_blog_splide');
	if ($blog) {
		const $blogSplide = new Splide($blog, {
			rewind: true,
			gap: 10,
			arrows: false,
			pagination: false,
			mediaQuery: 'min',
			breakpoints: {
				1156: {
					fixedWidth: 247,
					gap: 32,
				}
			}
		});
		$blogSplide.mount();
	}
}

function creatorsModal() {
	const $close = document.querySelectorAll('button[data-c-modal-close]');
	const $moBtn = document.querySelectorAll('.creators-modal-btn');
	if ($moBtn.length > 0) {
		const $modal = document.querySelector('.c-modal__innr');
		const $mo_img = $modal.querySelector('.c-modal-face__img');
		const $mo_title = $modal.querySelector('.c-modal__title');
		const $mo_nameEn = $modal.querySelector('.c-modal-name__en');
		const $mo_nameJa = $modal.querySelector('.c-modal-name__ja');
		const $mo_comment = $modal.querySelector('.c-modal__comment');

		$moBtn.forEach(b => {
			b.onclick = async (e) => {
				$mo_img.src = await e.target.dataset.img;
				$mo_title.innerText = await e.target.dataset.title;
				$mo_nameEn.innerText = await e.target.dataset.nameEn;
				$mo_nameJa.innerText = await e.target.dataset.nameJa;
				$mo_comment.innerHTML = await e.target.dataset.comment.replace('\\n', '<br>');
				await $body.classList.add('is-show-creator-modal');
				bodyFixedOn();
			}
		});

		$close.forEach(c => {
			c.onclick = () => {
				$body.classList.remove('is-show-creator-modal');
				bodyFixedOff();
			}
		});
	}
}

// モーダル　動画再生
async function moviesModal() {
	const $moBtn_mv = await document.querySelectorAll('[data-videoid]');
	if ($moBtn_mv.length > 0) {

		// youtube API 呼び出し
		let youtube_apitag = await document.createElement('script');
		youtube_apitag.src = await "https://www.youtube.com/iframe_api";
		// let firstScriptTag = await document.querySelector('head');
		await document.head.appendChild(youtube_apitag);

		// Iframe準備完了
		youtube_apitag.onload = () => {

			const $close_mv = document.querySelector('.c-modal-close__btn');
			const $modal_mv = document.querySelector('.c-modal__innr');
			let $videoID, $videoType, player;

			$moBtn_mv.forEach(b => {
				b.onclick = async (e) => {
					$videoID = await b.dataset.videoid;
					$videoType = await b.dataset.videotype;
					await $modal_mv.classList.add($videoType);
					await $body.classList.add('is-show-movie-modal');
					bodyFixedOn();

					player = new YT.Player('movie-player', {
						// height: '360',
						// width: '640',
						videoId: $videoID,
						playerVars: {
							'autoplay': 1,
							'controls': 1,
						},
						events: {
							'onReady': onPlayerReady,
						},
					});

				}

				$close_mv.onclick = () => {
					$body.classList.remove('is-show-movie-modal');
					$modal_mv.classList.remove($videoType);
					bodyFixedOff();
					player.destroy();
				}

			});

		}

	}

	function onPlayerReady(e) {
		// e.target.mute();
		e.target.playVideo();
	}
}

// セミオーダー スムーススクロール
function semiOrderScrollTo() {
	const anchBtn = document.getElementById('toSimulator');
	if(anchBtn != null){
		anchBtn.addEventListener('click', function(e){
			const tgtId = this.getAttribute('href').replace(/^#/, '');
			e.preventDefault();
			document.getElementById(tgtId).scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'center'
			}, false);
		});
	}
}

// セミオーダー タブ
function semiOrderTab () {
	const $tabTrigger = document.querySelectorAll('[data-tab-target');
  // console.log($tabTrigger);
	if ($tabTrigger.length) {

		for (let i = 0; i < $tabTrigger.length; i++) {
			$tabTrigger[i].addEventListener('click', tabSwitch);
		}

		function tabSwitch() {
			// activeクラスを削除して付与する
			for (let i = 0; i < $tabTrigger.length; i++) {
				$tabTrigger[i].classList.remove('is-active');
			}
			this.classList.add('is-active');

			// show クラスを削除
			document.querySelectorAll('.semi-order__tabs .is-show')[0].classList.remove('is-show');

			//タブのインデックスから同じインデックスのコンテンツにshowクラスを付与する
			let $tabsTarget = document.querySelector(this.dataset.tabTarget);

			$tabsTarget.classList.add('is-show');
		}

	}
}

function productsFilterDropdown() {
	const $drop_tgl = document.querySelectorAll('.stat-dropdown-tgl');
	if ($drop_tgl.length > 0) {
		$drop_tgl.forEach(t => {
			t.onclick = () => {
				$body.classList.toggle('is-filter-dropdown-show');
			}
		});
	}
}

// 商品の絞り込み検索
function searchFilter() {
	const filterSelector = document.querySelectorAll('.products-filter__select');
	if(filterSelector != null){
		var collectionSelector = document.getElementById('condCollection'),
			typeSelector = document.getElementById('condType'),
			priceSelector = document.getElementById('condPrice'),
			orderSelector = document.getElementById('condOrder');
		var collections = '',
			type = '',
			price = '',
			order = '';
		for(let i=0;i<filterSelector.length;i++){
			filterSelector[i].addEventListener('change', function(){
				if(collectionSelector != null && typeSelector != null){
					collections = '/collections/'+collectionSelector.value+'?';
					type = typeSelector.value;
				}else{
					const currentUrl = new URL(window.location.href);
					const params = currentUrl.searchParams;
					params.delete('filter.v.price.gte');
					params.delete('filter.v.price.lte');
					params.delete('sort_by');
					var collections = currentUrl.href+'?';
				}
				price = priceSelector.value;
				order = orderSelector.value;
				location.href = collections+type+price+order;
			});
		}
	}
}

function productSlide() {
	const $mainSplide = document.querySelector('#prod_img_main_splide');
	if ($mainSplide) {
		const $thumbSplide = document.querySelector('#prod_img_thumb_splide');

		const $main = new Splide($mainSplide, {
			type: 'fade',
			rewind: true,
			arrows: false,
			pagination: false,
		});

		const $thumb = new Splide($thumbSplide, {
			gap: 8,
			// fixedWidth: 48,
			perPage: 6,
			rewind: true,
			arrows: false,
			pagination: false,
			isNavigation: true,
			wheel: true,
			waitForTransition: false,
			mediaQuery: 'min',
			breakpoints: {
				1156: {
					// perPage: 6,
					fixedWidth: 77,
					heightRatio: 0.667,
					direction: 'ttb',
				}
			}
		});

		$main.sync($thumb);
		$main.mount();
		$thumb.mount();
	}
}

function semiorderSlide() {
	const $semiMainSplide = document.querySelector('#semiorder_img_main_splide');
	if ($semiMainSplide) {
		const $semiThumbSplide = document.querySelector('#semiorder_img_thumb_splide');

		const $semiMain = new Splide($semiMainSplide, {
			type: 'fade',
			rewind: true,
			arrows: false,
			pagination: false,
		});

		const $semiThumb = new Splide($semiThumbSplide, {
			gap: 8,
			// fixedWidth: 48,
			perPage: 6,
			rewind: true,
			arrows: false,
			pagination: false,
			isNavigation: true,
			wheel: true,
			waitForTransition: false,
			mediaQuery: 'min',
			// breakpoints: {
			// 	1156: {
			// 		// perPage: 6,
			// 		fixedWidth: 77,
			// 		heightRatio: 0.667,
			// 		// direction: 'ttb',
			// 	}
			// }
		});

		$semiMain.sync($semiThumb);
		$semiMain.mount();
		$semiThumb.mount();
	}
}


// ブログ一覧ページ モーダル表示ロジック
function blogsModalOpen() {
	if(document.querySelector(".blog-widget-modal")) {
		const blogWidgetModal = document.querySelector(".blog-widget-modal")
		const blogWidgetHeader = document.querySelector(".blog-widget-header")
		blogWidgetHeader.addEventListener("click", () => {
			blogWidgetModal.classList.toggle("modal-visible")
		})
	}
}

function ready() {
	scrolled();
	scrollTop();
	drawerTgl();
	tglHeaderSearch();
	creatorsModal();
	productsFilterDropdown();
	searchFilter();
	blogsModalOpen();
	moviesModal();
	semiOrderScrollTo();
	semiOrderTab();

	const $splider = document.querySelectorAll('.splide');
	if ($splider.length > 0) {
		const script = document.createElement('script');
		script.src = splideUrl;
		script.async = true;
		document.head.appendChild(script);
		script.onload = () => {
			idxRecoSlide();
			idxBlogSlide();
			productSlide();
			semiorderSlide();
		}
	}
}

if (document.readyState !== 'loading') {
	$body = document.body;
	ready();
} else {
	window.addEventListener('DOMContentLoaded', function () {
		$body = document.body;
		ready();
	});
}

document.addEventListener('readystatechange', (event) => {
	if (event.target.readyState === 'complete') { }
});